
export const appliedFilterForDashboard = (panelObj, appliedfilterKeys, filterDef) => {
  // Requires deep clone an object otherwise the filter will eat up all data and become empty.
  const newPanelObj = { ...panelObj };
  // If panel object is empty or is a card, quit early so doesn't break the app.
  // The card would relies on backend for filtering - so......
  if (
    !newPanelObj || !newPanelObj.data || appliedfilterKeys === null) {
    return panelObj;
  }

  const appliedFilterKeysArray = appliedfilterKeys.map(key => key.split('-|'));

  // Get all the amount of categories that requires to be found.
  let categoryFoundCount = 0;
  [...new Set(appliedFilterKeysArray.map(item => item[1]))]
    .filter(item => item !== undefined) // Panel filter skips the check from the container.
    .forEach((filterCategory) => {
      Object.keys(panelObj.categories).forEach((category) => {
        if (
          filterCategory === category
          || (filterCategory && filterCategory.replace(/ /g, '') === category)
        ) {
          categoryFoundCount += 1;
        }
      });
    });

  newPanelObj.data = newPanelObj.data.filter((datum) => {
    let status = false;
    let foundCount = 0; // Initialise the initial modal for placing found matches.

    // Loop through the filters to find any data matches with the filter terms.
    appliedFilterKeysArray.forEach((item) => {
      const category = item[1];
      if (!category) return false; // Panel filter skips the check from the container.
      const categoryNoSpace = category.replace(/ /g, '');
      const compare = datum[category] || datum[categoryNoSpace];
      const compareToList = filterDef[category] ? filterDef[category][item[2]] : [];

      // If matches, add into the found list.
      if (compareToList && compareToList.related && compareToList.related.length > 0) {
        compareToList.related.forEach((relate) => {
          if (compare === relate) {
            foundCount += 1;
          }
        });
      }

      return true;
    });

    // Show the data if the amount of expect finding equals to what has been found.
    // A "found" (child) is always mapped with a "categoryFound" (Parent), thus, it
    // needs to be the same to determine the filter is applicable.
    // e.g. '0-Area-freezer', both "Area" and "freezer" needs to be found in the list.
    // if either is not found or some is repeated twice, there is something wrong with
    // the filter and needs to be re-applied.
    status = (foundCount === categoryFoundCount);
    return status;
  });

  return newPanelObj;
};
